import React, { useState, useEffect } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { getFieldQuestion } from '../util';

const AssetInventoryHeader = (
  {
    showFormFile,
    assetInventories,
    activeAssetInventory,
    timezone,
    getTextFileHeader,
  }) => {
  const lan = useLanguage();
  const theme = useTheme();
  const [fields, setFields] = useState([]);
  useEffect(() => {
    if (
      Array.isArray(assetInventories) &&
      assetInventories[activeAssetInventory]
    ) {
      setFields(assetInventories[activeAssetInventory].fields || []);
    } else {
      setFields([]);
    }
  }, [activeAssetInventory, assetInventories]);
  const AssetInventoryFields = () => {
    const assetInventoryFields = [];
    const defaultFields = ['id', 'name', 'type', 'brand', 'model', 'serialNumber'];
    if (
      !Array.isArray(assetInventories) ||
      !assetInventories[activeAssetInventory]
    ) {
      return null;
    }
    const currentInventory = assetInventories[activeAssetInventory];
    defaultFields.forEach((defaultField) => {
      const value = currentInventory[defaultField];

      if (value != null && value !== '') {
        assetInventoryFields.push(
          <Grid
            container
            id={`default-field-${defaultField}`}
            sx={{ p: 0.5, ml: 1, mr: 1 }}
          >
            <Grid size={12}>
              <Grid container alignItems="flex-start" spacing={1}>
                <Grid
                  size={3}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    wordBreak: 'break-word',
                    typography: 'body2',
                    color: theme.palette.text.secondary,
                  }}
                >
                  {lan[defaultField]}
                </Grid>
                <Grid size={9}>
                  <TextField
                    value={value}
                    variant="outlined"
                    fullWidth
                    multiline
                    slotProps={{ input: { readOnly: true } }}
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: theme.palette.action.hover,
                        paddingY: 0.5,
                        paddingX: 1.25,
                      },
                      '& .MuiOutlinedInput-input': {
                        fontSize: 13,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      }
    });
    fields?.forEach((field, i) => {
      if (
        field.title !== 'Name' &&
        field.title !== 'Type' &&
        field.title !== 'Brand' &&
        field.title !== 'Serial Number' &&
        field.title !== 'Model'
      ) {
        assetInventoryFields.push(
          <Box id={`Forms-row-${i}`} sx={{ mt: 1 }}>
            {getFieldQuestion(field, showFormFile, timezone, lan, getTextFileHeader, true)}
          </Box>
        );
      }
    });
    return assetInventoryFields;
  };
  return <AssetInventoryFields />;
};
export default AssetInventoryHeader;
//Original code:
/*import React, { useState, useEffect } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import TextareaAutosize from 'react-textarea-autosize';
import Grid from '@mui/material/Grid2';
import { getFieldQuestion } from '../util';

const AssetInventoryHeader = ({
	showFormFile,
	assetInventories,
	activeAssetInventory,
	timezone,
	getTextFileHeader
}) => {
	const lan = useLanguage();
	const [fields, setFields] = useState([]);
	useEffect(() => {
		setFields(assetInventories[activeAssetInventory].fields);
	}, [activeAssetInventory, assetInventories]);
	const AssetInventoryFields = () => {
		let assetInventoryFields = [];
		var defaultFields = ['id','name', 'type', 'brand', 'model', 'serialNumber'];
		let value = '';
		defaultFields.forEach((defaultField) => {
			value = assetInventories[activeAssetInventory][defaultField];
			if (value != null && value !== '') {
				assetInventoryFields.push(
					<Grid container className='mt-4'>
						<Grid size={10} className='ml-auto mr-5'>
							<Grid container>
								<Grid size={3}>{lan[defaultField]}</Grid>
								<Grid size={9}>
									<TextareaAutosize
										readOnly
										className={'task-details-input'}
										value={value}
										style={{
											width: '100%',
											paddingTop: '5px',
											paddingLeft: '10px',
											paddingBottom: '5px',
											paddingRight: '10px',
										}}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				);
			}
		});
		fields?.forEach((field, i) => {
			if (
				field.title !== 'Name' &&
				field.title !== 'Type' &&
				field.title !== 'Brand' &&
				field.title !== 'Serial Number' &&
				field.title !== 'Model'
			) {
				assetInventoryFields.push(
					<div key={'Forms-row-' + i} className='mt-4'>
						{getFieldQuestion(field, showFormFile, timezone, lan, getTextFileHeader, true)}
					</div>
				);
			}
		});
		return assetInventoryFields;
	};
	return <AssetInventoryFields />;
};
export default AssetInventoryHeader;
*/
